<bb-page-header [icon]="'paper-plane'" [title]="'PROJECTS' | translate" [filterConfig]="filterConfig"
	[currentPath]="listConfiguration.activePath">
</bb-page-header>
<div class="body-column">

	<div class="action-buttons">
		<a class="button" [routerLink]="['/library/project', 'new', 'metadata']"><i class="fa fa-plus"></i>
			<span class="short-label">{{ 'CREATE_NEW' | translate }}</span>
			<span class="long-label">{{ 'CREATE_NEW_PROJECT' | translate }}</span>
		</a>

		<div class="with-selected" [ngClass]="{'has-selected': selectedRows.length > 0}" [hasPermission]="'cloning'">
			<span *ngIf="!selectedRows || selectedRows.length === 0" class="selected-label">{{ 'NO_PROJECTS_SELECTED' |
				translate }}</span>
			<span *ngIf="selectedRows.length > 0" class="selected-label">{{ 'X_PROJECTS_SELECTED' | translate : {x:
				selectedRows.length} }}:</span>
			<bb-cloning-info [selectedRows]="selectedRows" [hasPermission]="'cloning'"></bb-cloning-info>
		</div>
	</div>

	<bb-table-container>

		<bb-table-header>
			<bb-table-header-cell class="column-thumbnail"></bb-table-header-cell>
			<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="title">{{ 'TITLE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="name">{{ 'NAME' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="status" class="icon">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell property="createddate" class="date">{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="updateddate">{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row" (dblclick)="redirectToDetails(row.id)">
			<bb-table-cell class="thumb">
				<bb-table-thumbnail [entity]="row.data"></bb-table-thumbnail>
			</bb-table-cell>
			<bb-table-cell property="id">{{ row.id }}</bb-table-cell>
			<bb-table-cell class="overflow" property="title">{{ row.data.title }}</bb-table-cell>
			<bb-table-cell class="overflow" property="name">{{ row.data.name }}</bb-table-cell>
			<bb-table-cell property="status"><span [innerHTML]="row.data | statusIcon"></span></bb-table-cell>
			<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{
				row.data.createddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}
			</bb-table-cell>
			<bb-table-cell property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">{{
				row.data.updateddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy">{{ row.data.updatedBy }}
			</bb-table-cell>
			<bb-table-cell class="row-actions buttons" (click)="$event.stopPropagation()">
				<!-- stopPropagation so the row doesn't get selected -->
				<a class="button" [routerLink]="['/library/project', row.data.id, 'metadata']">
					<i class="fa fa-edit" (easterEgg)="showData(row.data.id)"></i>
				</a>

				<a class="button" (click)="showPreview(row.data)">
					<i class="fa fa-eye"></i>
				</a>

				<a class="button root" [ngClass]="{disabled: !putRight}" (click)="deleteSingle(row.data)">
					<i class="fa fa-trash"></i>
				</a>
			</bb-table-cell>
		</bb-table-row>

	</bb-table-container>

	<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_PROJECTS_FOUND' | translate }}</div>

	<bb-table-pager></bb-table-pager>

</div>
